import clientConfigApi from '../config/config'
import axios from 'axios';
import { token } from '../config/constant';

export const VODData = (path) => {
  let VODData = {}
  return async dispatch => {
    VODData = await clientConfigApi.post(
      path,
      {
        "payload": {},
        "header": {
          "sessionToken": token
        },
      }
    )
      .catch(
        (response) => {
          console.log("Api failed with the status code:", response)
        }
      )
    //console.log("movies api", VODData);
    if (VODData && VODData.data) {
      dispatch({
        type: 'Fetch_VOD_Data',
        payload: VODData.data
      })
    }
  }
}

export const changePage = (pageNumber) => {
  return {
    type: 'Update_Page_Number',
    payload: pageNumber
  }
}

export const changeGenrePage = (pageNumber) => {
  return {
    type: 'Update_Genre_Page_Number',
    payload: pageNumber
  }
}

export const changeLangPage = (lang, indexOfLang, callFromLang) => {
  return {
    type: 'Update_Lang_Page',
    payload: {
      lang,
      callFromLang,
      indexOfLang
    }
  }
}

export const setCurrentMovie = (currentMovie) => {
  return {
    type: 'Update_Current_Movie',
    payload: currentMovie
  }
}
export const setPreviousMovie = (movie) => {
  return {
    type: 'Update_Previous_Movie',
    payload: movie
  }
}
export const nextMovie = (movie) => {
  return {
    type: 'Update_Next_Movie',
    payload: movie
  }
}

export const setCategoryMovieList = (movieList) => {
  return {
    type: 'Update_Movie_List',
    payload: movieList
  }
}